import * as React from "react";
import ActiveStatusControl from "../../core/ActiveStatusControl/ActiveStatusControl";
import BackButton from "../../core/BackButton/BackButton";
import ErrorModal from "../../core/ErrorModal/ErrorModal";
import Spinner from "../../core/Spinner/Spinner";
import Toast from "../../core/Toast/Toast";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import ILicenseKeyEditMaster from "../../types/ILicenseKeyEditMaster";
import IResponse from "../../types/IResponse";

interface ILicenseKeyEditMasterEditProps extends ITranslationProps {
    loading: boolean;
    licenseKey: ILicenseKeyEditMaster;
    saveLicenseKey: (licenseKey: ILicenseKeyEditMaster) => Promise<IResponse<ILicenseKeyEditMaster> | null>;
    toggleLicenseKeyStatus: (active: boolean) => void;
}

interface ILicenseKeyEditMasterEditState {
    validated: boolean;
    licenseKey: ILicenseKeyEditMaster;
    errorMessages: string[];
    showErrorModal: boolean;
}

class LicenseKeyEdit extends React.Component<ILicenseKeyEditMasterEditProps, ILicenseKeyEditMasterEditState> {

    public static getDerivedStateFromProps(nextProps: ILicenseKeyEditMasterEditProps, prevState: ILicenseKeyEditMasterEditState) {
        prevState.licenseKey = nextProps.licenseKey;
        return prevState;
    }

    private formElement: HTMLFormElement | null;
    private toastElement: Toast | null;

    constructor(props: ILicenseKeyEditMasterEditProps) {
        super(props);

        this.state = {
            validated: false,
            licenseKey: {
                keyName: "",
                postbackAuthHeader: "",
                clientDetailID: 0,
                isActive: true,
                licenseKey: ""
            },
            errorMessages: [],
            showErrorModal: false
        };

        this.onKeyNameChange = this.onKeyNameChange.bind(this);
        this.onPostbackAuthHeaderChange = this.onPostbackAuthHeaderChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.toggleIsActive = this.toggleIsActive.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
    }

    public render() {
        return (
            <div>
                {this.props.loading && <Spinner />}
                <BackButton />
                <h2>{this.props.licenseKey.clientDetailID > 0 ? this.props.t("LicenseKeyEdit.EditLicenseKey") : this.props.t("LicenseKeyEdit.CreateLicenseKey")}</h2>

                <form ref={ref => this.formElement = ref} className={this.state.validated ? "was-validated" : "needs-validation"} noValidate={true}>

                    <div className="card mt-3">
                        <div className="card-header">
                            <h5>{this.props.t("LicenseKeyEdit.LicenseKeyInformation")}</h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>{this.props.t("LicenseKeyEdit.KeyName")}</label>
                                <input type="text" className="form-control" placeholder={this.props.t("LicenseKeyEdit.KeyName")}
                                    value={this.state.licenseKey.keyName} onChange={this.onKeyNameChange} required={true} maxLength={150} autoFocus={true} />
                                <div className="invalid-feedback">
                                    {this.props.t("LicenseKeyEdit.KeyNameInvalid")}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>{this.props.t("LicenseKeyEdit.PostbackAuthHeader")}</label>
                                <input type="text" className="form-control" placeholder={this.props.t("LicenseKeyEdit.PostbackAuthHeader")}
                                    value={this.state.licenseKey.postbackAuthHeader} onChange={this.onPostbackAuthHeaderChange} required={false} maxLength={500} autoFocus={false} />
                            </div>

                            {this.props.licenseKey.clientDetailID > 0 &&
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label>{this.props.t("LicenseKeyEdit.LicenseKey")}</label>
                                            <div className="form-control">{this.state.licenseKey.licenseKey}</div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <ActiveStatusControl
                                            isActive={this.state.licenseKey.isActive}
                                            label={this.props.t("LicenseKeyEdit.Status")}
                                            activateConfirmationMessage={this.props.t("LicenseKeyEdit.ConfirmActivate")}
                                            inactivateConfirmationMessage={this.props.t("LicenseKeyEdit.ConfirmInactivate")}
                                            onConfirmation={this.toggleIsActive} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <button type="button" data-id="save-button" className="btn btn-primary mt-3 px-4"
                        onClick={this.onSaveClick}>{this.props.t("Global.SaveButton")}</button>
                </form>

                <ErrorModal
                    title={this.props.t("Global.Error")}
                    errors={this.state.errorMessages}
                    isOpen={this.state.showErrorModal}
                    onRequestClose={this.closeErrorModal} />

                <Toast ref={ref => this.toastElement = ref} />

            </div>
        );
    }

    private closeErrorModal() {
        this.setState({ showErrorModal: false, errorMessages: [] });
    }

    private async onSaveClick() {
        this.setState({ validated: true });

        if (this.formElement && this.formElement.checkValidity()) {

            const response = await this.props.saveLicenseKey(this.state.licenseKey);
            if (response) {
                if (response.success) {
                    if (this.toastElement) {
                        this.toastElement.success(this.props.t("Global.Success"), "");
                    }
                }
                else {
                    this.setState({ showErrorModal: true, errorMessages: response.errorMessages })
                }
            }

            this.setState({ validated: false });
        }
    }

    private onKeyNameChange(event: React.ChangeEvent<HTMLInputElement>) {
        const licenseKey = this.state.licenseKey;
        licenseKey.keyName = event.target.value;
        this.setState({ licenseKey });
    }

    private onPostbackAuthHeaderChange(event: React.ChangeEvent<HTMLInputElement>) {
        const licenseKey = this.state.licenseKey;
        licenseKey.postbackAuthHeader = event.target.value;
        this.setState({ licenseKey });
    }


    private async toggleIsActive() {
        await this.props.toggleLicenseKeyStatus(!this.state.licenseKey.isActive);
        if (this.toastElement) {
            this.toastElement.success(this.props.t("Global.Success"), "");
        }

    }
}

export default translateComponent(LicenseKeyEdit);



// WEBPACK FOOTER //
// ./src/components/LicenseKeyEdit/LicenseKeyEdit.tsx